/** @jsx jsx */
import { jsx } from "theme-ui"
import Svg from "./base"

const Icon = props => (
  <Svg width="140" height="140" {...props}>
    <path
      fill="#fff"
      d="M47.081 44.743l-5.091 12.27 13.083 1.678 3.938 12.685 11.09-7.19 11.106 7.174 3.905-12.703 13.084-1.693-5.108-12.255 8.931-9.78-11.733-6.077.61-13.283-12.87 2.939L70.053 7.93l-7.976 10.593-12.869-2.906.643 13.267-11.716 6.11 8.947 9.748zM69.903 24.12c9.063 0 16.412 7.405 16.412 16.538s-7.349 16.538-16.412 16.538c-9.063 0-16.428-7.405-16.428-16.538S60.84 24.12 69.903 24.12zm.181 49.614c-8.14 0-14.732 6.642-14.732 14.828s6.592 14.844 14.732 14.844c8.123 0 14.715-6.642 14.715-14.844 0-8.186-6.592-14.828-14.715-14.828z"
    ></path>
    <path
      fill="#fff"
      d="M116.123 77.072c-2.389-1.428-6.641-1.76-8.931 1.793-5.767 11.756-14.484 23.744-28.342 27.381l-8.783 6.708-9.112-6.974c-14.517-4.516-24.206-18.929-28.342-27.132-2.736-4.167-6.558-2.723-8.503-1.677-2.67 1.462-4.037 5.496-2.406 9.166 11.403 27.065 29.183 35.75 29.183 35.75v10.012l38.707.033-.182-9.962s18.703-9.216 28.903-35.816c1.268-3.62.906-7.44-2.192-9.282z"
    ></path>
  </Svg>
)

export default Icon
